<template>
  <div class="user-info-container">
    <div class="user-info-column">
      <el-form class="user-info-el-form" :model="form">
        <el-form-item label="新密码" label-width="120px">
          <el-input
            type="password"
            v-model="form.pwd"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" label-width="120px">
          <el-input
            type="password"
            v-model="form.pwdAgain"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pwdConfirm"> 确认修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { userInfo } from "@/common/js/userInfo";
import { RSA } from "@/common/rsa/rsa.js";

export default {
  mounted() {
    // console.log('qlx:    '+JSON.stringify(userInfo))
    //console.log(userInfo.userName);
    this.rsa = new RSA();
  },
  data() {
    return {
      // 密码实体
      form: {
        pwd: "",
        pwdAgain: "",
        rsa: null,
      },
      userInfo,
    };
  },
  methods: {
    pwdConfirm() {
      if (this.form.pwd !== this.form.pwdAgain) {
        this.$message.warning("密码不一致");
        return;
      }
      if (this.form.pwd.length < 6) {
        this.$message.warning("密码小于6位");
        return;
      }

      this.showPwdDialog = false;
      console.log(this.userInfo.userId);
      console.log(this.form.pwd);
      this.$api.user
        .modifyUser({
          data: {
            userId: this.userInfo.userId,
            passwd: this.form.pwd,
            // 'passwd': this.rsa.encryptPassword(this.form.pwd)
          },
        })
        .then((value) => {
          this.$message.success("修改成功");
          this.form = {
            pwd: "",
            pwdAgain: "",
          };
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../css/userinfo.scss";
</style>
